import { FieldProps, getIn } from 'formik';
import { SSNInput } from '../inputs/SSNInput/SSNInput';

interface IProps extends FieldProps {
  id?: string;
}

export const SSNInputField = ({ form, field, ...props }: IProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <SSNInput
      {...field}
      {...props}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
    />
  );
};
